import Vue from 'vue'
import moment from 'moment'
import {helpers} from './../../helpers';

export default {
    store: {
        namespaced: true,
        state: {
            endpoint: 'tasks',
            groups: {},
            project: {},
            projects: [],
            projectsUnsorted: [],
            tree: [],
            tasks: [],
            task: {},
            groupBy: localStorage.getItem('groupTasksBy') ? localStorage.getItem('groupTasksBy') : 'statuses',
            orderBy: localStorage.getItem('sortTasksBy') ? localStorage.getItem('sortTasksBy') : 'created_at',
            filterStatus: localStorage.getItem('filterTasksByStatus') ? localStorage.getItem('filterTasksByStatus') : 'all',
        },
        actions: {
            init({ dispatch }) {
                dispatch('getProjects');
            },

            //получение проектов
            getProjects({ state, rootState }) {
                return helpers.http.get({context: this, rootState}, '/tasks/project', { order_by: 'name' }).then(r => {
                    Vue.set(state, 'projects', r);
                    return r;
                });
            },

            //получение текущего проекта
            getProject({ state, rootState }) {
                let projectID = rootState.route.params.projectid;
                if (!projectID || projectID == 'all') return Vue.set(state, 'project', null);

                return helpers.http.get({context: this, rootState}, '/tasks/project/' + projectID).then(r => {
                    Vue.set(state, 'project', r);
                    return r;
                });
            },

            //получение задач с фильтром по группе и проекту (gorupId и projectId)
            getTasksNew({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                delete data.count;
                delete data.page;
                return helpers.http.get({context: this, rootState}, '/tasks', {params: data}).then(r => {
                    Vue.set(state, 'tasks', r);
                    return r;
                });
            },

            //получение задач с фильтром по группе и проекту (gorupId и projectId)
            getTasks({ state, rootState }, data) {
                let filter = (data && data.filter && data.filter.length) ? data.filter : [];
                let url   = ''
                let sort  = typeof data != 'undefined' && typeof data.sort  != 'undefined' ? data.sort  : 'created_at';
                let order = typeof data != 'undefined' && typeof data.order != 'undefined' ? data.order : 'desc';

                //фильтр по проекту
                if (typeof rootState.route.params.projectid != 'undefined' && rootState.route.params.projectid && rootState.route.params.projectid != 'all')
                    filter.push('["project_id", "=", "' + rootState.route.params.projectid + '"]')

                //фильтр по названию
                if (typeof rootState.route.query.search != 'undefined' && rootState.route.query.search.length > 0)
                    filter.push('["name", "%", "' + rootState.route.query.search + '"]')

                //фильтр по исполнителю
                if (typeof rootState.route.query.responsible_id != 'undefined')
                    filter.push('["responsible_id", "=", "' + rootState.route.query.responsible_id + '"]')

                //фильтр по создателю
                if (typeof rootState.route.query.taskmaster_id != 'undefined')
                    filter.push('["taskmaster_id", "=", "' + rootState.route.query.taskmaster_id + '"]')

                //фильтр по статусу
                if (typeof data != 'undefined' && typeof data.status != 'undefined' && data.status != 'all')
                    filter.push('["status", "=", "' + data.status + '"]')

                filter = filter.join(', "and", ')

                //фильтр по группе
                if (typeof rootState.route.query.group_id != 'undefined')
                    url = '/tasks/groups/' + rootState.route.query.group_id + '/tasks?order_by=' + sort + '&order_type=desc&filter=[' + (filter ? filter + ', "and", ' : '') + '["parent_task_id", "=", "null"]]'
                else
                    url = '/tasks?order_by=' + sort + '&order_type=' + order + '&filter=[' + (filter ? filter + ', "and", ' : '') + '["parent_task_id", "=", "null"]]'

                return helpers.http.get({context: this, rootState}, url).then(r => {
                    Vue.set(state, 'tasks', r);
                    return r;
                });
            },

            //получение задачи по id
            getTask({ state, rootState }, id) {
                let taskId = (id) ? id : rootState.route.params.taskid;
                return helpers.http.get({context: this, rootState}, '/tasks/byid/' + taskId).then(r => {
                    let task = r;
                    if (task.deadline == null) task.deadline = '';
                    else task.deadline = moment(task.deadline).toISOString();

                    task.child_tasks.forEach(child => {
                        if (child.deadline == null) child.deadline = '';
                        else child.deadline = moment(child.deadline).toISOString();
                    });

                    if (task.time.time_list.sort((a, b) => {
                        if (a.id < b.id) return 1;
                        if (a.id > b.id) return -1;
                        return 0;
                    }));

                    Vue.set(state, 'task', task);
                    return task;
                });
            },

            //получение групп
            getGroups({ rootState }, data) {
                data = {
                    order_by: 'name',
                    filter: [
                        ['name',    '%', data.name ],'and',
                        ['user_id', '=', rootState.users.current.id]
                    ]
                };
                return helpers.http.get({context: this, rootState}, '/tasks/groups',  {params: data});
            },

            //получение всех групп
            getAllGroups({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/tasks/groups', {params: data}).then(r => {
                    Vue.set(state, 'groups', r);
                    return r;
                });
            },

            //добавление группы
            addGroupNew({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/tasks/groups', data);
            },

            //добавление группы
            async addGroup({ rootState, dispatch }, options) {
                //делаем запрос для проверки на сущестовании группы
                let group = await helpers.http.get({context: this, rootState}, '/tasks/groups', {params: {
                    filter: [['name', '=', options.group_name]]
                }}).then(group => {
                    if (group && Array.isArray(group) && group.length) return group[0];
                    else return null;
                });

                //если группа не найдена, то создаём её и также прикрепляем к ней задачу и возвращаем группу в ответе
                if (!group) group = await helpers.http.post({context: this, rootState}, '/tasks/groups', { name: options.group_name });

                //прикрепляем к ней задачу и возвращаем группу в ответе
                await helpers.http.post({context: this, rootState}, '/tasks/addgroup', { task_id: options.task_id, group_id: group.id });
                await dispatch('getTasks');

                return group;
            },

            //удаление задачи из группы
            deleteTaskFromGroup({ rootState, dispatch }, data) {
                data = {task_id: data.task_id, group_id: data.group_id};
                return helpers.http.delete({context: this, rootState}, '/tasks/addgroup', {params: data}).then(() => dispatch('getTasks'));
            },

            //обновление группы
            updateGroup({ rootState }, options) {
                return helpers.http.put({context: this, rootState}, '/tasks/groups', options.group);
            },

            //удаление группы
            deleteGroup({ state, rootState }, options) {
                state.groups = state.groups.filter(group => parseInt(group.id) == parseInt(options.group_id));
                return helpers.http.delete({context: this, rootState}, '/tasks/groups/' + options.group_id);
            },

            //добавление проекта
            addProject({ rootState }, options) {
                return helpers.http.post({context: this, rootState}, '/tasks/project', { name: options.name });
            },

            //удаление проекта
            deleteProject({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/tasks/project/' + options.id);
            },

            //изменение проекта
            updateProject({ rootState }, options) {
                return helpers.http.put({context: this, rootState}, '/tasks/project', options.project);
            },

            //добавление задач
            postTask({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/tasks', data);
            },

            //обновление задачи
            putTask({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/tasks', data);
            },

            //обновление задачи
            updateTask({ dispatch, rootState }, options) {
                //присваеваем null, если строка пустая. компонент datetime работает только со строками, а в БД нельзя отдавать пустую строку
                if (!options.task.deadline) options.task.deadline = null;
                else options.task.deadline = moment(options.task.deadline).format('DD-MM-YYYY HH:mm:ss');
                if (!options.task.type) options.task.type = 1

                return helpers.http.post({context: this, rootState}, '/tasks', options.task).then(r => {
                    dispatch('getTasks');
                    return r;
                });
            },

            //удаление задачи
            deleteTask({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/tasks/byid/' + options.task_id);
            },

            //удаление подзадачи
            deleteChildTask({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/tasks/byid/' + options.id);
            },

            //получение списка статусов текущего проекта
            getProjectStatuses({ state, rootState }, options) {
                let projectID = options && options.project_id ? options.project_id : null;
                if (!projectID && rootState.route.params.projectid) projectID = rootState.route.params.projectid;
                let data = {filter: [['project_id', '=', projectID]]};

                return helpers.http.get({context: this, rootState}, '/tasks/status', {params: data}).then(r => {
                    Vue.set(state, 'projectStatuses', r);
                    return r;
                });
            },

            //получение списка статусов текущей задачи
            getTaskStatuses({ state, rootState }, options) {
                let projectId = null;
                if (state.task.project_id) projectId = state.task.project_id;
                if (options && options.project_id) projectId = options.project_id;
                let data = {filter: [['project_id', '=', projectId]]};

                return helpers.http.get({context: this, rootState}, '/tasks/status', {params: data}).then(r => {
                    Vue.set(state, 'taskStatuses', r);
                    return r;
                });
            },

            //изменение статуса задачи
            changeStatus({ rootState, dispatch }, options) {
                return helpers.http.post({context: this, rootState}, '/tasks/status/change', {
                    task_id:   options.task_id,
                    status_id: options.status_id
                }).then(r => {
                    dispatch('getTasks');
                    return r;
                });
            },

            //добавление статуса
            addStatus({ rootState }, options) {
                return helpers.http.post({context: this, rootState}, '/tasks/status', {
                    name: options.status_name,
                    project_id: options.project_id
                });
            },

            //обновление статуса
            updateStatus({ rootState }, options) {
                return helpers.http.put({context: this, rootState}, '/tasks/status', options.status);
            },

            //удаление статуса
            deleteStatus({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/tasks/status/' + options.status_id);
            },

            //добавление соисполнителя
            addCoexecutor({ rootState }, options) {
                return helpers.http.post({context: this, rootState}, '/tasks/coexecutor', {
                    task_id: options.task_id,
                    executor_id: options.executor_id
                });
            },

            //удаление соисполнителя
            deleteCoexecutor({ rootState }, options) {
                return helpers.http.delete({context: this, rootState}, '/tasks/' + options.task_id + '/coexecutor/' + options.executor_id);
            },

            //старт таймера выполнения задачи
            getTimelineByTaskId({ rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/tasks/' + id + '/time');
            },



            removeTime({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/tasks/time/' + id);
            },
            postTime({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/tasks/time', data);
            },
            putTime({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/tasks/time', data);
            },



            //Далее старые методы

            //старт таймера выполнения задачи
            startTimer({ state, rootState, dispatch }, options) {
                let offset = moment().utcOffset() - 180; //разница в минутах с Московским временем
                let time   = moment().add(offset, 'm').format('DD-MM-YYYY HH:mm:ss'); //время начала

                return helpers.http.put({context: this, rootState}, '/tasks/time', {
                    task_id: options.task.id,
                    time_start: time,
                    user_id: rootState.users.current.id
                }).then(r => {
                    state.task.time.time_list.unshift(r);
                    return r;
                });
            },

            //остановка таймера выполнения задачи
            stopTimer({ rootState, dispatch }, options) {
                //последний временной отрезок
                let userTimes = options.task.time.time_list.filter(time => time.user_id == rootState.users.current.id);
                let lastTime  = userTimes[0];

                let offset = moment().utcOffset() - 180; //разница в минутах с Московским временем
                lastTime.time_finish = moment().add(offset, 'm').format('DD-MM-YYYY HH:mm:ss'); //время окончания

                return helpers.http.put({context: this, rootState}, '/tasks/time', lastTime).then(() => dispatch('getTask'));
            },

            //обновление временного промежутка выполнения задачи
            updateTime({ rootState, dispatch }, options) {
                return helpers.http.put({context: this, rootState}, '/tasks/time', options.time).then(r => {
                    dispatch('getTask');
                    return r;
                });
            },

            //удаление временного промежутка выполнения задачи
            deleteTime({ state, rootState, dispatch }, options) {
                state.task.time.time_list.forEach((time, index) => {
                    if (time.id == options.id) state.task.time.time_list.splice(index, 1)
                });

                return helpers.http.delete({context: this, rootState}, '/tasks/time/' + options.id).then(() => dispatch('getTask'));
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/tasks/store.js